export enum StorageKeyEnum {
    JWT_AUTHORIZATION = 'JWTAuthorization'
}